<span>{{ 'Conversation::BatchTaggingCompletedMessage' | abpLocalization: tagNames }}</span>
